import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=174cacd8&scoped=true&"
import script from "./ForgetPassword.vue?vue&type=script&lang=ts&"
export * from "./ForgetPassword.vue?vue&type=script&lang=ts&"
import style0 from "./ForgetPassword.vue?vue&type=style&index=0&id=174cacd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174cacd8",
  null
  
)

export default component.exports